import {
  DataGrid,
  DateBox,
  DropDownBox,
  List,
  SelectBox,
} from "devextreme-react";
import {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import moment from "moment";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { axiosGet, axiosPost } from "../../apis/useAxios";
import DataSource from "devextreme/data/data_source";

export default function ActivityRawDataComponent() {
  const [state, setState] = useState({
    isFilterSubmitted: false,
    isActivityApiLoading: false,
    filterDropdownEmployeeDataSource: [],
    filterEmployeeNumber: "",
    filterDatetime: new Date(moment().startOf("day")),
    crewActivityGridDataSource: [],
  });
  const refDataGrid = useRef();
  const refLstEmployees = useRef(null);
  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML = `Raw Data`;
  });
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnLoad = async () => {
    try {
      setTimeout(async () => {
        await GetfilterDropdownEmployee();
      }, 0);
      setTimeout(async () => {
        await getCrewRawData();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  const GetfilterDropdownEmployee = async () => {
    try {
      debugger;
      const res = await axiosGet(`/Crew/get-crew-dropdown`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
      });
      setState((prev) => ({
        ...prev,
        filterDropdownEmployeeDataSource: res?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const handleOnFilterGridDataSource = async () => {
    try {
      setState((prev) => ({
        ...prev,
        isFilterSubmitted: true,
        isActivityApiLoading: true,
      }));
      await getCrewRawData();
      setState((prev) => ({
        ...prev,
        isFilterSubmitted: false,
        isActivityApiLoading: false,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const getCrewRawData = async () => {
    try {
      debugger;
      var request = {};
      request.AirlineCode = sessionStorage.getItem("session_airlineCode");
      request.EmployeeNumber = state.filterEmployeeNumber;
      let res = await axiosPost("CrewActivity/crew-raw-data", request);
      setState((prev) => ({
        ...prev,
        crewActivityGridDataSource: res?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <style>{`
        /* ── Activity Raw Data — theme matching sidebar #8E6448 ── */
        .ca-filter-card {
          border: 1px solid #e8d5c4 !important;
          background: #fdf7f2 !important;
        }
        .ca-filter-body {
          padding: 0.75rem 1rem 0.5rem 1rem;
        }
        .ca-filter-body label {
          font-size: 0.72rem !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          color: #7a4f2e !important;
          margin-bottom: 3px !important;
        }
        .ca-btn-search {
          background: linear-gradient(135deg, #8E6448, #b07d5c) !important;
          border: none !important;
          color: #fff !important;
          font-size: 0.78rem !important;
          font-weight: 600 !important;
          padding: 5px 14px !important;
          border-radius: 5px !important;
        }
        .ca-btn-search:hover { opacity: 0.9 !important; }
        .ca-btn-clear {
          background: #f0e8e0 !important;
          border: 1px solid #c9a98a !important;
          color: #7a4f2e !important;
          font-size: 0.78rem !important;
          font-weight: 600 !important;
          padding: 5px 14px !important;
          border-radius: 5px !important;
        }
        .ca-btn-clear:hover { background: #e4d3c3 !important; }
        .ca-grid-wrap .dx-header-row td {
          background-color: #8E6448 !important;
          color: #ffffff !important;
          font-size: 0.76rem !important;
          font-weight: 600 !important;
          letter-spacing: 0.02em !important;
          border-color: rgba(255,255,255,0.15) !important;
        }
        .ca-grid-wrap .dx-datagrid-filter-row td {
          background-color: #f5ede4 !important;
        }
        .ca-grid-wrap .dx-datagrid {
          border-radius: 8px !important;
          overflow: hidden !important;
          box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
        }
        .ca-grid-wrap .dx-toolbar {
          background: #fdf7f2 !important;
          border-bottom: 1px solid #e8d5c4 !important;
          padding: 0.35rem 0.6rem !important;
        }
      `}</style>
      <div className="filter-box mb-0">
        <div
          className="card ca-filter-card p-0 m-0"
          style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
        >
          <div className="ca-filter-body">
            <div className="row">
              <div className="col-lg-2 col-md-2">
                <div className="form-group">
                  <label>Employee Number</label>
                  <DropDownBox
                    value={state.filterEmployeeNumber}
                    valueExpr="employeeNumber"
                    displayExpr="employeeName"
                    deferRendering={false}
                    showClearButton={true}
                    dataSource={state.filterDropdownEmployeeDataSource}
                    onValueChanged={() => {
                      if (refLstEmployees.current?.instance) {
                        refLstEmployees.current.instance.unselectAll();
                        refLstEmployees.current.instance.option(
                          "searchValue",
                          "",
                        );
                      }
                      setState((prev) => ({
                        ...prev,
                        filterEmployeeNumber: "",
                      }));
                    }}
                    contentRender={() => {
                      return (
                        <List
                          ref={refLstEmployees}
                          dataSource={
                            new DataSource({
                              store: state.filterDropdownEmployeeDataSource,
                              sort: "employeeName",
                              sortOrder: "asc",
                              paginate: true,
                              pageSize: 10,
                            })
                          }
                          height={400}
                          keyExpr="employeeNumber"
                          displayExpr="employeeName"
                          searchEnabled={true}
                          searchExpr={["employeeNumber", "employeeName"]}
                          searchMode="contains"
                          pageLoadMode="scrollBottom"
                          showSelectionControls={true}
                          selectionMode={"single"}
                          indicateLoading={true}
                          selectByClick={true}
                          onItemClick={(item) => {
                            try {
                              setState((prev) => ({
                                ...prev,
                                filterEmployeeNumber:
                                  item?.itemData?.employeeNumber ?? "",
                              }));
                            } catch (error) {
                              console.log("List.onItemClick", error);
                            }
                          }}
                        />
                      );
                    }}
                    placeholder="Select Employee"
                  />
                </div>
              </div>
              <div className="col-lg-2 col-md-2">
                <div className="form-group has-feedback">
                  <div>
                    <br />
                  </div>
                  <button
                    type="button"
                    className="ca-btn-search"
                    onClick={async () => {
                      await handleOnFilterGridDataSource();
                    }}
                  >
                    <span title="Search">
                      <i
                        className={`fas fa-${
                          state.isFilterSubmitted ? "spinner fa-spin" : "filter"
                        }`}
                      ></i>
                      &nbsp;Search
                    </span>
                  </button>
                  &nbsp; &nbsp;
                  <button
                    type="button"
                    className="ca-btn-clear"
                    onClick={() => {
                      setState((prev) => ({
                        ...prev,
                        filterEmployeeNumber: "",
                      }));
                    }}
                  >
                    <span title="Clear">
                      <i className="fas fa-eraser"></i> Clear
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card ca-grid-wrap mt-0"
        style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
      >
        <div className="card-body">
          <div>
            <DataGrid
              ref={refDataGrid}
              dataSource={state.crewActivityGridDataSource}
              columnAutoWidth={true}
              showColumnLines={true}
              showRowLines={true}
              showBorders={true}
              rowAlternationEnabled={false}
              allowColumnResizing={true}
              onCellPrepared={(e) => {
                if (e.rowType === "header") {
                  e.cellElement.style.backgroundColor = "#8E6448";
                  e.cellElement.style.color = "#ffffff";
                }
              }}
            >
              <Column
                dataField="id"
                caption=""
                allowSorting={false}
                allowSearch={false}
                allowExporting={false}
                allowFiltering={false}
                fixed={true}
                width={"30"}
                visible={false}
              />
              <Column
                dataField="employeeNo"
                caption="Employee Number"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityTime"
                caption="Activity Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityType"
                caption="Activity Type"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="dutyType"
                caption="Duty Type"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="flyAirportPickup"
                caption="Fly Airport Pickup"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="dutyId"
                caption="Duty #"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityCode"
                caption="Activity Code"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityLocationCode"
                caption="Activity Location Code"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="baseStation"
                caption="Base Station"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="airportCode"
                caption="Airport Code"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="origin"
                caption="Origin"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="destination"
                caption="Destination"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="sequenceNumber"
                caption="Sequence Number"
                allowSearch={true}
                width={200}
              />

              <Column
                dataField="maximumDutySeq"
                caption="Maximum Duty Seq"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityStartTime"
                caption="Activity Start Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityEndTime"
                caption="Activity End Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="flightTime"
                caption="Flight Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="flightNumber"
                caption="Flight Number"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="dutyReportingTime"
                caption="Duty Reporting Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="deBriefingTime"
                caption="De-Briefing Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="airlineType"
                caption="Airline Type"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="createdDateTime"
                caption="Created Date Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="notificationBatchId"
                caption="Notification Batch #"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="requestSessionId"
                caption="Request Session #"
                allowSearch={true}
                width={200}
              />
              <HeaderFilter visible={true} />
              <Paging defaultPageSize={20} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
                showInfo={true}
                visible={true}
              />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Export
                enabled={true}
                allowExportSelectedData={false}
                fileName="CrewActivity"
              />
            </DataGrid>
          </div>
        </div>
      </div>
    </div>
  );
}
